import { render, staticRenderFns } from "./EditRuleModal.vue?vue&type=template&id=6d9674c0&scoped=true"
import script from "./EditRuleModal.vue?vue&type=script&lang=js"
export * from "./EditRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9674c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9674c0')) {
      api.createRecord('6d9674c0', component.options)
    } else {
      api.reload('6d9674c0', component.options)
    }
    module.hot.accept("./EditRuleModal.vue?vue&type=template&id=6d9674c0&scoped=true", function () {
      api.rerender('6d9674c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/QuestionnaireSystem/components/CreateQuesRule/components/EditRuleModal.vue"
export default component.exports